module.exports = __webpack_public_path__ + "media/media/about/comm-4-be0d99fd17392d5f1dda960164208671.png";